module.exports = __webpack_public_path__ + "img/生产-服装合格证.e85d0840.jpg";